import { Grid, Paper, styled } from "@mui/material";

export const StyledAttendance = {
  GridContainer: styled(Grid)(({ theme }) => ({
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundImage: "linear-gradient(120deg, #96d43a, #539aff)",
    width: "100vw",
    height: "100vh",
  })),

  FormContainer: styled(Paper)(({ theme }) => ({
    maxWidth: "100vw",
    minWidth: "250px",
    backgroundColor: "white",
    boxShadow: "0px 0px 5px 0px grey",
    borderRadius: "10px",
    padding: "30px 25px 10px 25px",
  })),
};
